import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
window.$store = store

Vue.config.productionTip = false

import anime from 'animejs/lib/anime.es.js';
window.anime = anime

import './style/index.scss'
import styleSettings from './style/settings.scss'
window.style = styleSettings

import __id from './lib/newID'
window.__id = __id


new Vue({
    router,
    render: h => h(App)
}).$mount('#app');


